<template>

    <Grid>

        <Column :span="[ 2, 3, 4 ]">

            <div class="skeleton h-7 w-9/12 md:w-80 lg:w-96"/>

            <div class="skeleton h-72 md:h-96 mt-9 md:pr-8 lg:pr-16 md:w-11/12"/>

        </Column>

        <Column :span="[ 2, 2 ]" class="mt-16">

            <div class="skeleton h-4 w-full mt-2"/>

            <div class="skeleton h-4 w-full mt-14"/>

            <div class="skeleton h-4 w-full mt-14"/>

            <div class="skeleton px-4 h-4 mr-2 w-full mt-12"/>

            <div class="skeleton px-4 h-4 mr-2 mt-8 w-full"/>

            <div class="skeleton mt-8 h-4 w-2/6"/>

        </Column>

    </Grid>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'

    export default defineComponent({
        name: 'OpenSourcePackageSkeleton',
        components: {
            Grid,
            Column
        }
    })

</script>
